import _ from 'underscore';
import { IContext } from '../../types/context.types';
import { getAlertFlags, IAlertFlags } from './alert-information';
import { i18nMap, isAvailable, isBillingLinkPermission } from '../../utils';
import {
  DismissMode,
  INotification,
  NotificationLevel,
  TargetComponent,
  ScopeLevel,
} from '../../types/notification.types';

export class UETNotifications {
  context: IContext;
  i18n: any;
  availableScopes: ScopeLevel[];

  constructor(context: IContext) {
    this.context = context;
    this.i18n = context.getNewI18n();
    this.availableScopes = [ScopeLevel.account];
  }

  async getUETNotifications(): Promise<INotification[]> {
    if (!this.context.getUserContext().CurrentUser.IsInternal && isBillingLinkPermission(this.context.getSettingsContext())) {
      return [];
    }

    const currentScope = this.context.getCurrentScope();
    if (!isAvailable(currentScope, this.availableScopes)) {
      return [];
    }

    const fields = ['HasMsClickIdTaggingEnabled', 'HasGoals'];
    const alertFlags: IAlertFlags = await getAlertFlags(fields, this.trimScopeToAccount());

    if (!alertFlags.HasMsClickIdTaggingEnabled && alertFlags.HasGoals) {
      return [
        {
          target: TargetComponent.UnifiedQueue,
          dismissMode: DismissMode.permanent,
          severity: NotificationLevel.Warning,
          title: this.i18n.getString(i18nMap.Alert_Uet_EnableAutoTagging_Title),
          scopeLevel: ScopeLevel.account,
          availableScopes: this.availableScopes,
          message: this.i18n.getString(i18nMap.Alert_Uet_EnableAutoTagging),
          condition: true,
          id: 'Notification_UET_EnableAutoTagging',
          actionList: [
            {
              text: this.i18n.getString(i18nMap.UnifiedNotificationQueue_Action_AutoTaggingLink),
              href: '/campaign/vnext/accountsettings',
              callbackType: 'closeQueue',
              extraClassNames: undefined,
              extraAttrs: undefined,
            },
          ],
        },
      ];
    }
    return [];
  }

  trimScopeToAccount() {
    const scope = this.context.getCurrentScope();
    const values = _.assign({}, scope.values);
    values.adGroupId = undefined;
    values.campaignId = undefined;

    return {
      values,
      location: scope.location,
    };
  }
}
